module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.errors) ? _c('div', {
    staticClass: "error-info red-text"
  }, [_c('i', {
    staticClass: "mfind-icon-x"
  }), _vm._v(_vm._s(_vm.errors.join(', ')) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11dae120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/errorMessage.vue
// module id = 360
// module chunks = 0